export default __webpack_public_path__ + "static/media/correct.7994ff34.wav";